import { Component } from '@angular/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  get content() {
    return this.dataShareService.tenantConfig.common?.privacyPolicy || '';
  }

  constructor(private dataShareService: DataShareService) {
    // Empty
  }
}
